import Link from "next/link";
import { getContentNavItems } from "@/lib/content/nav";

// Drop-in nav list for content-engine pages. Renders <li> links for every
// content page that opted into `nav` for the given group. Renders nothing when
// no page opts in, so it's safe to place anywhere (footer column, etc.).
//
// Usage:
//   <ContentNavList group="features" />
export default function ContentNavList({ group }: { group?: string }) {
  const items = getContentNavItems(group);
  if (items.length === 0) return null;

  return (
    <>
      {items.map((item) => (
        <li key={item.href}>
          <Link href={item.href} aria-label={item.label}>
            {item.label}
          </Link>
        </li>
      ))}
    </>
  );
}
